import BaseApiAction from '@Actions/base-api-action';

export default class SwitchProfileSuper extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'auth-switchProfileSuper',
      payload: {
        user_id: this._payload.user_id,
      },
    });
  }
}
